module.exports = __webpack_public_path__ + "static/img/11b994cfeb2be8be.8d2bf45c.png";